// globals.js

export const murphyPanelAsistente = {
    title: window.murphyPanelAsistente?.title,
    logo: window.murphyPanelAsistente?.logo,
    titleColor: window.murphyPanelAsistente?.titleColor,
    logoColorBorder: window.murphyPanelAsistente?.logoColorBorder,
    textButton: window.murphyPanelAsistente?.textButton,
    bgColorGlobal: window.murphyPanelAsistente?.bgColorGlobal,
    buttonLogo: window.murphyPanelAsistente?.buttonLogo,
    bgColorMessage: window.murphyPanelAsistente?.bgColorMessage,
    bgColorResponse: window.murphyPanelAsistente?.bgColorResponse,
    // iconAvatarMessage: window.murphyPanelAsistente?.iconAvatarMessage,
    // iconAvatarResponse: window.murphyPanelAsistente?.iconAvatarResponse,
    onOpen: window.murphyPanelAsistente.onOpen,
    onClose: window.murphyPanelAsistente.onClose,

}

export const getMurphyPanelAsistente = (configVar) => {
    return murphyPanelAsistente[configVar];
}
